
import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Gift, Mail, Calendar } from "lucide-react";
import PageLayout from "@/layouts/PageLayout";

const PledgeSuccess = () => {
  const [searchParams] = useSearchParams();
  const tier = searchParams.get("tier");
  const anonymous = searchParams.get("anonymous");

  const tierInfo = {
    "early-supporter": {
      name: "Early Supporter",
      description: "2 months promotional access",
      gifts: "Standard gift package"
    },
    "movement-builder": {
      name: "Movement Builder", 
      description: "6 months promotional access",
      gifts: "Standard gift package"
    },
    "revolution-partner": {
      name: "Revolution Partner",
      description: "12 months promotional access", 
      gifts: "Standard + exclusive gifts"
    }
  };

  const currentTier = tier ? tierInfo[tier as keyof typeof tierInfo] : null;

  return (
    <PageLayout showBackButton={false}>
      <div className="min-h-screen bg-secondary/5 py-12 px-6">
        <div className="max-w-3xl mx-auto">
          <Card className="text-center">
            <CardHeader className="pb-6">
              <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
                <CheckCircle2 className="h-8 w-8 text-green-600" />
              </div>
              <CardTitle className="text-2xl text-green-700">
                Thank You for Your Pledge!
              </CardTitle>
              {currentTier && (
                <p className="text-lg text-muted-foreground">
                  Welcome to the {currentTier.name} tier
                </p>
              )}
            </CardHeader>
            <CardContent className="space-y-6">
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <h3 className="font-medium text-blue-900 mb-2 text-center">What happens next?</h3>
                <div className="space-y-3 text-sm text-blue-800">
                  <div className="flex flex-col items-center gap-3 text-center">
                    <Mail className="h-4 w-4 flex-shrink-0" />
                    <div>
                      <p className="font-medium">Email Confirmation</p>
                      <p>You'll receive a confirmation email with your pledge details.</p>
                    </div>
                  </div>
                  <div className="flex flex-col items-center gap-3 text-center">
                    <Gift className="h-4 w-4 flex-shrink-0" />
                    <div>
                      <p className="font-medium">Appreciation Gifts</p>
                      <p>Your {currentTier?.gifts} will be shipped to your provided address as our way of saying thank you.</p>
                    </div>
                  </div>
                  <div className="flex flex-col items-center gap-3 text-center">
                    <Calendar className="h-4 w-4 flex-shrink-0" />
                    <div>
                      <p className="font-medium">Platform Launch (December 2025)</p>
                      <p>We'll email you with account creation instructions when cheqbooq launches. Your promotional pricing will continue seamlessly.</p>
                    </div>
                  </div>
                </div>
              </div>

              {currentTier && (
                <div className="bg-gray-50 rounded-lg p-4">
                  <h3 className="font-medium mb-2 text-center">Your Pledge Benefits</h3>
                  <ul className="text-sm text-muted-foreground space-y-1 text-center">
                    <li>• {currentTier.description}</li>
                    <li>• {currentTier.gifts}</li>
                    <li>• Early access to cheqbooq platform</li>
                    <li>• Exclusive supporter badge</li>
                    <li>• Regular updates on development progress</li>
                  </ul>
                </div>
              )}

              <div className="pt-4">
                <Link to="/">
                  <Button className="w-full sm:w-auto">
                    Return to Home
                  </Button>
                </Link>
              </div>

              <p className="text-xs text-muted-foreground">
                Questions? Contact us at support@cheqbooq.com
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </PageLayout>
  );
};

export default PledgeSuccess;
